
interface Grouping<T> {
  grouper: string
  list: T[]
}
interface Groupings<T> {
  [state: string]: Grouping<T>
}

// Inspired by django's {% regroup cities by country as country_list %} template tag
export const regroup = <T extends {}>(items: readonly T[], getGrouperFn: (item: T) => string, grouperSortFn?: (a: Grouping<T>, b: Grouping<T>) => number) => 
  Object.values(
    items.reduce<Groupings<T>>((groups, item) => {
      
      const key = getGrouperFn(item);
      const group: Grouping<T> = groups[key] || {
        grouper: key,
        list: [],
      }
      group.list.push(item)
      return {
        ...groups,
        [key]: group,
      }

    }, {})
  ).sort((a,b) => grouperSortFn?.(a, b) ?? a.grouper.localeCompare(b.grouper));
